<template>
  <div class="pa-10">
    <HTEInternRequestDataTable />
  </div>
</template>

<script>
import HTEInternRequestDataTable from "@/components/Utils/HTEInternRequestDataTable.vue";
export default {
  components: {
    HTEInternRequestDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
